// extracted by mini-css-extract-plugin
module.exports = {"containerOption":"Ak","step":"Bk","container":"Ck","cols":"Dk","leftCol":"Ek","rightCol":"Fk","initiate":"Gk","boxErrorMsg":"Hk","labelDelivery":"Ik"};